import { useEffect, useState } from "react";
import TypoHome from "./TypoHome";
import { Backdrop, Box, CircularProgress, Container, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { Reducers } from "../../../redux/reducers";
import UserInformation from "../../../types/UserInformation";
import {
  PROFIL_ADV, PROFIL_DIRECTION, PROFIL_MANAGER,
  PROFIL_ROA, PROFIL_SUPER_ADMIN
} from "../../../constants/Constants";
import { PeriodSaisi } from "../production/SaisieAgent";
import { createStyles, makeStyles } from "@material-ui/core";
import { dateToString } from "../../../utils/utils";
import Cookies from "universal-cookie";
import axios, { AxiosInstance } from "axios";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      color: "#FC8404"
    }
  })
);

interface ManualItem {
  title: string;
  description: JSX.Element;
  icon: string;
}

interface DateClotureData {
  id: number,
  annee: number,
  date_cloture: string
}

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

const Acceuil = () => {
  const classes = useStyles();

  const logger = useSelector<Reducers>((state) => state.logger) as UserInformation;

  const cookies = new Cookies();
  const token: string = cookies.get('jwt');

  const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    }
  });

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [periodSaisi, setPeriodSaisi] = useState<PeriodSaisi>({
    date_debut: "",
    date_fin: "",
    date_verrouillage: "",
  });

  const [dateClotureData, setDateClotureData] = useState<DateClotureData | null>(null);

  /**
   * Récupère la date de verrouillage
   */
  const getDateVerrouillage = async () => {
    await http.post("saisie/manager/get-period-to-enter/quantities")
      .then((res) => {
        setPeriodSaisi(res?.data?.period_saisi);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /**
   * Récupère la date de cloture
   */
  const getDateCloture = async () => {
    await http.post("date-cloture/find-one")
      .then((res) => {
        setDateClotureData(res?.data);
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    // Récupère la date de verrouillage
    getDateVerrouillage();

    // Récupère la date de cloture
    getDateCloture();
  }, []);

  const dateMoinsUn = (initialDate: string) => {
    let date = new Date(initialDate);
    date.setDate(date?.getDate() - 1);

    return dateToString(date);
  };

  const manualItemForRoaOrManager: ManualItem[] = [
    {
      title: "Report de la saisie des quantités fixes",
      description: <TypoHome variant="subtitle2" align="justify">Si l'Article est semi-automatique, alors SuiviRenta remplit automatiquement la quantité de cet article chaque mois.</TypoHome>,
      icon: "images/efficiency.png"
    },
    {
      title: "Date verrouillage saisie",
      description: <TypoHome variant="subtitle2" align="justify">On ne peut saisir sur une période verrouillé. La Date de verrouillage est planifié le <span className={classes.root}>{periodSaisi?.date_verrouillage}</span>,
        alors j’aurais jusqu'à <span className={classes.root}>{dateMoinsUn(periodSaisi?.date_verrouillage)}</span> pour finir mes saisis.</TypoHome>,
      icon: "images/calendar.png"
    },
    {
      title: 'Article désactivé',
      description: <TypoHome variant="subtitle2" align="justify">On peut saisir sur un article désactivé dans un période inférieur à la date de désactivation de ce dernier.</TypoHome>,
      icon: "images/writing.png"
    }
  ];

  const RGDésactivation = [
    <TypoHome variant="subtitle2" align="justify">Si tous les opérations d’un client sont désactivés, alors le client sera désactivé automatiquement,
      de même pour opération - article, si tous les articles d’une opération sont désactivés, alors l'opération sera désactivé automatiquement</TypoHome>,
    <TypoHome variant="subtitle2" align="justify">L’activation d’un client n’active pas automatiquement les opérations du client,
      de même pour opération - articles</TypoHome>
  ];

  const dynamicDateClotureText = () => {
    let dynamicText;
    if (dateClotureData?.id) {
      dynamicText = <TypoHome variant="subtitle2" align="justify">
        La Date de clôture est planifié le <span className={classes.root}>{dateClotureData?.date_cloture}</span>, alors j’aurais jusqu'à <span className={classes.root}>{dateMoinsUn(dateClotureData.date_cloture)}</span> pour finir mes saisis.
      </TypoHome>;
    } else {
      dynamicText = <TypoHome variant="subtitle2" align="justify">
        Pour le moment il n'y as pas de date de clôture paramétrer. Donc vous pouvez modifier ou ajouter des saisies à n'importe quel moment.
      </TypoHome>
    }

    return <>
      <TypoHome variant="subtitle2" align="justify">
        Une fois la période a été clôturé, alors on ne peut plus y faire des saisies même pour ADV.
      </TypoHome>
      {dynamicText}
    </>;
  };

  const manualItemForAdvOrAdminOrDirection: ManualItem[] = [
    {
      title: 'Date Cloture',
      description: dynamicDateClotureText(),
      icon: "images/calendar.png"
    },
    {
      title: 'Désactivation Client - Opération - Article',
      description: RGDésactivation[Math.floor(Math.random() * RGDésactivation.length)],
      icon: "images/checklist.png"
    },
    {
      title: "Report de la saisie des quantités fixes",
      description: <TypoHome variant="subtitle2" align="justify">Si l'Article est semi-automatique, alors SuiviRenta remplit automatiquement la quantité de cet article chaque mois.</TypoHome>,
      icon: "images/efficiency.png"
    }
  ];

  let isManagerOrRoa = false;
  let manualFunctionality: ManualItem[] | null = null;
  switch (logger?.profils?.libelle) {
    case PROFIL_MANAGER:
    case PROFIL_ROA:
      isManagerOrRoa = true;
      manualFunctionality = manualItemForRoaOrManager;
      break;
    case PROFIL_ADV:
    case PROFIL_SUPER_ADMIN:
    case PROFIL_DIRECTION:
      manualFunctionality = manualItemForAdvOrAdminOrDirection;
      break;
  }

  const showNotificationMessage = () => {
    if (isManagerOrRoa) {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth();
      let dateMoins7 = new Date(year, month + 1, 0);
      dateMoins7.setDate(dateMoins7?.getDate() - 7);

      if (dateToString(dateMoins7) === dateToString(date)) {
        return true;
      }

      return false;
    }

    return false;
  };

  return (
    <Container maxWidth="lg" sx={{ mb: '4rem' }}>
      {showNotificationMessage() && (
        <Container maxWidth="md">
          <Box display="flex" justifyContent="center" mt='2rem' mb='1rem'>
            <TypoHome variant="h4" marked="center" component="h2">
              Notification date de verrouillage
            </TypoHome>
          </Box>

          <Box>
            <TypoHome variant="subtitle1">
              Bonjour {logger?.prenom},
            </TypoHome>
            <TypoHome variant="subtitle1" align="justify">
              Afin de clôturer le cycle de facturation des clients au niveau du Groupe dans les délais impartis, nous vous demandons de bien vouloir finaliser la saisie des éléments de facturation, dans SIRENTA V2, relatifs à la période du <span className={classes.root}>{periodSaisi?.date_debut}</span> au <span className={classes.root}>{periodSaisi?.date_fin}</span>, pour le <span className={classes.root}>{dateMoinsUn(periodSaisi?.date_verrouillage)} 23H:59</span> au plus tard.
            </TypoHome>
            <TypoHome variant="subtitle1" align="justify" my={1}>
              La date de verrouillage de la saisie étant planifiée le <span className={classes.root}>{periodSaisi?.date_verrouillage}</span>, toute modification des éléments de facturation postérieure à cette date devra être transmise directement à votre interlocuteur du service ADV pour une prise en compte sur la facture du client.
            </TypoHome>
            <TypoHome variant="subtitle1" align="justify">
              Nous nous tenons à votre disposition pour tout complément d’informations, et vous remercions par avance pour votre coopération.
            </TypoHome>
            <TypoHome variant="subtitle1" sx={{ my: 3 }}>
              Bien cordialement.
            </TypoHome>
            <TypoHome variant="subtitle1">
              Le service ADV
            </TypoHome>
          </Box>
        </Container>
      )}

      {manualFunctionality && (
        <>
          <Box
            display="flex"
            justifyContent="center"
            mt={showNotificationMessage() ? '8rem' : '2rem'}
            mb={showNotificationMessage() ? '3rem' : '6rem'}
          >
            <TypoHome variant="h4" marked="center" component="h2">
              Manuel des fonctionnalités
            </TypoHome>
          </Box>

          {!isLoading && (
            <Grid container spacing={4} columns={{ xs: 6, sm: 8, md: 12 }}>
              {manualFunctionality?.map((item, index) => (
                <Grid item xs={6} sm={4} md={(manualFunctionality!?.length > 2) ? 4 : 6} key={index}>
                  <Box>
                    <Box
                      component="img"
                      src={item?.icon}
                      alt={item?.title}
                      sx={{
                        height: 75,
                        my: 4,
                        textAlign: 'center',
                        margin: 'auto',
                        display: 'flex'
                      }}
                    />
                    <TypoHome variant="h6" align="left" sx={{ mt: 4, color: '#FC8404' }}>
                      {item?.title}
                    </TypoHome>
                    {item?.description}
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}
        </>
      )}

      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </Container>
  );
};

export default Acceuil;
